export default __webpack_public_path__ + "static/media/24.02312389.png";